import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Animation {
    constructor(container, options = {}, refs = null) {
        // console.info(`Animation.constructor(${container}, ${options}, ${refs})`);

        this.defaults = {
            toggleActions: 'play none none none',
            start: 'center',
            end: 'center',
            markers: false, // debug markers
            once: false, // destroy after element enters viewport
            scrub: false, // set animation progress to match scrollbar (numbers are seconds)
        };

        this.config = { ...this.defaults, ...options };

        this.el = {
            container,
            refs,
        };

        gsap.registerPlugin(ScrollTrigger);

        this.scrollTrigger = ScrollTrigger.create({
            trigger: this.el.container,
            start: `top ${this.config.start}`,
            end: `bottom ${this.config.end}`,
            scrub: this.config.scrub,
            markers: this.config.markers,
            animation: this.config.animation,
        });
    }
}
